import React from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Statistic } from 'antd';
import { calculateLoadColor } from 'shared/utils/trips/load-color-calculator';
import { CardUi } from 'components/common/card-ui';
import type { ITripTotalInfoProps } from 'components/trips/trip-total-info/types';

export const TripTotalInfo: React.FC<ITripTotalInfoProps> = (props) => {
  const { totalLDM, totalWeight, totalVolume, loadByLDM, loadByWeight, status } = props;
  const { t } = useTranslation();

  const color = calculateLoadColor(loadByWeight, loadByLDM, status);

  return (
    <CardUi>
      <Flex gap='large' justify='space-between'>
        <Flex gap='large'>
          <Statistic title={t('common:LDM')} value={totalLDM || '–'} suffix='m' />
          <Statistic title={t('common:weight')} value={totalWeight || '–'} suffix='kg' />
          <Statistic title={t('common:volume')} value={totalVolume || '–'} suffix='m³' />
        </Flex>
        <Flex gap='large'>
          <Statistic title={t('common:ldm_load')} value={loadByLDM || '–'} valueStyle={{ color }} suffix='%' />
          <Statistic title={t('common:weight_load')} value={loadByWeight || '–'} valueStyle={{ color }} suffix='%' />
        </Flex>
      </Flex>
    </CardUi>
  );
};
